import { Grid, GridSpacing } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

interface SkeletonConfig {
  height?: number;
  width?: number;
  gridWidth: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  varient: "circle" | "rect" | "text" | "empty";
}

interface SkeletonGrid {
  align?: "flex-start" | "center" | "flex-end";
  justify?:
    | "flex-start"
    | "center"
    | "flex-end"
    | "space-between"
    | "space-around";
  spacing?: GridSpacing;
  configList: SkeletonConfig[];
}

export const SkeletonLoader = (props: {
  width: number;
  height?: number;
  animation?: "pulse" | "wave" | false;
  spacing?: GridSpacing;
  skeletonGrid: SkeletonGrid[];
  bodyStyle?: any;
}) => {
  const { width, height, bodyStyle, spacing, skeletonGrid, animation } = props;
  return (
    <Grid
      container
      spacing={spacing}
      style={{
        width: `${width}px`,
        height: height ? `${height}px` : "auto",
        ...bodyStyle
      }}
    >
      {skeletonGrid.map((gline: SkeletonGrid) => {
        return (
          <Grid item xs={12}>
            <Grid
              container
              justify={gline.justify || "flex-start"}
              alignItems={gline.align || "center"}
              spacing={gline.spacing || 1}
            >
              {gline.configList.map((gl: SkeletonConfig) => {
                return (
                  <Grid item xs={gl.gridWidth}>
                    {gl.varient === "empty" ? (
                      <></>
                    ) : (
                      <Skeleton
                        animation={animation}
                        variant={gl.varient}
                        height={gl.height}
                        width={gl.width}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};
